import axios from '@/common/axios'

export const getOrgAlerts = (path) => axios.get('/api/org_alerts', { params: { path } })
